export type GuidanceTier = "low" | "moderate" | "high" | "none";

/** Pure: tier from guidance/capacity ratio. `none` = unknown (render muted, never green/zero). */
export function guidanceTier(
  guidanceHours: number | null,
  capacityHours: number | null,
): GuidanceTier {
  if (guidanceHours === null) return "none";
  if (capacityHours === null || capacityHours <= 0) return "none";
  const ratio = guidanceHours / capacityHours;
  if (ratio <= 0.7) return "low";
  if (ratio <= 1.0) return "moderate";
  return "high";
}

/** Pure: free capacity as a 0–100 percent. null = unknown. Overload clamps to 0 (never negative). */
export function availabilityPercent(
  guidanceHours: number | null,
  capacityHours: number | null,
): number | null {
  if (guidanceHours === null) return null;
  if (capacityHours === null || capacityHours <= 0) return null;
  const pct = ((capacityHours - guidanceHours) / capacityHours) * 100;
  return Math.max(0, Math.min(100, Math.round(pct)));
}
